import * as R from 'ramda';
import React, {Component} from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';
import t from 'tcomb-form';

import 'react-datepicker/dist/react-datepicker.css';

export default class FormDatetimePicker extends Component {
    static displayName = 'FormDatePicker';

    constructor(props) {
        super(props);
        const {value, options} = props;
        this.state = {
            value: value ? moment(value) : null,
            minDate: options.minDate,
            maxDate: options.maxDate,
            disabled: options.disabled
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value) {
            this.setState({
                value: moment(nextProps.value)
            });
        } else if (nextProps.options.flightEndDate) {
            this.setState({
                value: nextProps.options.flightEndDate,
                minDate: nextProps.options.minDate
            });
        }
    }

    handleChange = value => {
        const {onChange, ctx} = this.props;
        this.setState({value}, () => {
            onChange(this.getValue(), ctx.path);
        });
    };

    toggleIsEditable = e => {
        e.preventDefault();
        const {disabled} = this.state;
        this.setState({
            disabled: !disabled
        });
    };

    getValue = () => {
        const value = R.pathOr(null, ['state', 'value'], this);
        return value && value.unix ? value.unix() : null;
    };

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.getValue();
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    render() {
        const {options, ctx} = this.props;
        const label = options.label || ctx.label;
        const labelNode = <label className="control-label">{label}</label>;
        const attrs = options.attrs || {};

        return (
            <div {...attrs}>
                {labelNode}

                <Datetime
                    dateFormat="MMM D, YYYY"
                    timeFormat="h:mm A [GMT]Z"
                    defaultValue={options.defaultValue || ''}
                    onChange={this.handleChange}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_datetimepicker.js